import { createSelector } from 'reselect';

import './storeInitialiser';

const selectChat = (state) => state.Chat;

export const selectNumUnreadConversations = createSelector(
  selectChat,
  (chat) => {
    return chat.get('numUnreadConversations');
  }
);
